import { EventEmitterAsync } from "../../../lib/web/core/event-emmiter-async";
import { Injectable } from "../../../lib/web/reflection/injectable";
import { MediaPlayerComponent } from "../components/organisms/media-player/media-player.component";
import { VjsMediaPlayerComponent } from "../components/organisms/vjs-media-player/vjs-media-player.component";

export type MediaType = 'capsule' | 'trailer' | 'video';

export interface MediaControls {
    miniPlayer?: 'enable' | 'disable';
    enableFullScreen?: boolean;
    chromecast?: boolean;
    back?: boolean;
    minimize?: boolean;
    skip?: boolean;
    skipText?: string;
    embed?: boolean;
    closeOnEnd?: boolean;
    isPreview?: boolean;
}

export interface MediaOptions {
    type: MediaType;
    capsuleId?: number;
    collectionId?: number;
    image?: string;
    currentTime?: number;
    embed?: boolean;
    owner?: {
        pathname: string;
        target: string;
    },
    video?: {
        id: string | number,
        secret?: string,
        title: string,
        isPreview?: boolean
    },
    controls?: MediaControls;
    parentalPin?: string;
    selectedSignLanguage?: string;
}

@Injectable({ type: 'singleton' })
export class MediaPlayerService {

    private _mediaPlayer: MediaPlayerComponent = null;
    private _vjsMediaPlayer: VjsMediaPlayerComponent = null;
    private _eventEmmiter: EventEmitterAsync = new EventEmitterAsync();

    public setMediaPlayer(mediaPlayer: MediaPlayerComponent): void {
        this._mediaPlayer = mediaPlayer;
    }

    public setVjsMediaPlayer(vjsMediaPlayer: VjsMediaPlayerComponent): void {
        this._vjsMediaPlayer = vjsMediaPlayer;
    }

    public loadMedia(playerType: 'brightcove' | 'v2', media: MediaOptions): void {
        if (playerType === 'brightcove') {
            this._mediaPlayer.load(media);
        }
        else {
            this._vjsMediaPlayer.load(media);
        }
    }

    public miniPlayerActivated(): void {
        this._eventEmmiter.emit('mini-player-activated');
    }

    public miniPlayerDeactivated(): void {
        this._eventEmmiter.emit('mini-player-deactivated');
    }

    public closePlayer(playerType: 'brightcove' | 'v2'): void {
        if (playerType === 'brightcove') {
            this._mediaPlayer?.close();
        }
        else {
            this._vjsMediaPlayer?.close();
        }
    }

    public playerClosed(e: { ended: boolean }): void {
        this._eventEmmiter.emit('player-closed', e);
    }

    public on(eventName: 'mini-player-activated' | 'mini-player-deactivated' | 'player-closed', callback: (...args: any[]) => Promise<void>, owner: any): void {
        this._eventEmmiter.on(eventName, callback);
    }

    public off(owner: any): void {
        this._eventEmmiter.offOwner(owner);
    }

    public currentMedia(playerType: 'brightcove' | 'v2'): MediaOptions {
        if (playerType === 'brightcove') {
            return this._mediaPlayer.options;
        }
        else {
            return this._vjsMediaPlayer.options;
        }
    }

    public isMiniPlayerActive(playerType: 'brightcove' | 'v2'): boolean {
        if (playerType === 'brightcove') {
            return this._mediaPlayer.isMiniPlayerActive;
        }
        else {
            return this._vjsMediaPlayer.isMiniPlayerActive;
        }
    }
}
